import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
import { TIMELINE_SERVICE_ID } from './timeline.js';
const ITimelineService = ( createDecorator(TIMELINE_SERVICE_ID));
export { ITimelineService };
